import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://api.mojkomsija.rs/'
  // baseURL: 'http://test.mojkomsija.rs/',
  // baseURL: 'http://10.241.122.154/PhpstormProjects/moj-komsija-back/'
  baseURL: process.env.VUE_APP_KOMSIJA_BACK
});

const financesInstance = axios.create({
  baseURL: process.env.VUE_APP_BLAGAJNA_API
});

export { financesInstance };

// instance.defaults.headers.common['Auth'] = '';

export default instance;
